import { TypographyVariant } from './Typography.models';

export const getTag = (variant: TypographyVariant) => {
  switch (variant) {
    case 'body1':
    case 'body2': {
      return 'p';
    }
    default: {
      return variant;
    }
  }
};
